import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user || user === false) {
      setIds([]);
      return;
    }
    try {
      const { data } = await api.get("/wishlist/ids");
      setIds(data || []);
    } catch {
      setIds([]);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const toggle = async (productId) => {
    if (!user || user === false) return { in_wishlist: false, requireAuth: true };
    const { data } = await api.post(`/wishlist/${productId}`);
    setIds((prev) =>
      data.in_wishlist ? [...prev, productId] : prev.filter((p) => p !== productId),
    );
    return data;
  };

  const has = (productId) => ids.includes(productId);

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, refresh, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
